import axios from 'axios'
import {
  requestHandler,
  responseHandler,
  responseErrorHandler
} from 'services/Instances/utils'

import { ApiType, getAxiosConfiguration, errorHandler } from './configuration'

const axiosConfiguration = getAxiosConfiguration(ApiType.Cdu)
const cduApiClient = axios.create(axiosConfiguration)

cduApiClient.interceptors.request.use(requestHandler, errorHandler)
cduApiClient.interceptors.response.use(responseHandler, responseErrorHandler)

export { cduApiClient }
